
//window._ = require('lodash');
import jQuery from 'jquery'
window.$ = window.jQuery = jQuery

import _ from 'lodash';
window._ = _;

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */
//import Popper from 'popper.js';
//import jQuery from 'jQuery';
import * as bootstrap from 'bootstrap'
//import bootstrap from 'bootstrap';

try {
    //window.Popper = require('popper.js').default;
    window.Popper = Popper;
    //window.$ = window.jQuery = jQuery;

    window.bootstrap = bootstrap;
    //require('bootstrap');
    //require('admin-lte');
} catch (e) {}

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

 //const token_bearer = localStorage.getItem('access_token');
 //window.axios = require('axios');
import axios from 'axios';
window.axios = axios;

//const token1 = "49|7PJbQy1Jel1RESWvnHRJ0BU4M945W4zxlAqTZ7Lz";
//console.log(window.axios.defaults.headers);

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
window.axios.defaults.headers.common["Accept"] = "application/json";
window.axios.defaults.withCredentials = true;
    //window.axios.defaults.baseURL = "http://conta.p"; //Before sending get request
    //    axios.get("/sanctum/csrf-cookie").then(async () => {
    //    //Logic to handle login
    //});


    window.axios.defaults.baseURL = "https://beta.fsystems.ro"; //Before sending get request
        axios.get("/sanctum/csrf-cookie").then(async () => {
        //Logic to handle login
    });


    //window.axios.defaults.headers.common.Authorization = `Bearer ${userData.token}`
/**
 * Next we will register the CSRF Token as a common header with Axios so that
 * all outgoing HTTP requests automatically have it attached. This is just
 * a simple convenience so we don't have to attach every token manually.
 */

let token = document.head.querySelector('meta[name="csrf-token"]');
let cookiez = window.document.cookie;

var start_pos = cookiez.indexOf('|') + 1;
var end_pos = cookiez.indexOf(';',start_pos);
var text_to_get = cookiez.substring(start_pos,end_pos);

let bearer;
bearer = text_to_get;

if(bearer && bearer.length==40){
    localStorage.Bearer = 'Bearer '+bearer;
    window.axios.defaults.headers.common['Authorization'] = 'Bearer '+bearer;
    
    //console.log(window.axios.defaults.headers.common['Authorization']);
    //console.log('e');
}
else {
    localStorage.Bearer = null;
    bearer = null;
    //console.log('nu e');
}
//console.log(localStorage.Bearer);

if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.log(token);
    //console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo'

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
//     encrypted: true
// });

//VITE
// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: import.meta.env.VITE_PUSHER_APP_KEY,
//     cluster: import.meta.env.VITE_PUSHER_APP_CLUSTER,
//     encrypted: true
// });